// extracted by mini-css-extract-plugin
export var circle = "_25-2";
export var icon = "_25-a";
export var iconHighlight = "_25-0";
export var lg = "_25-8";
export var md = "_25-7";
export var outline = "_25-4";
export var sm = "_25-6";
export var square = "_25-1";
export var xl = "_25-9";
export var xs = "_25-5";
export var xxs = "_25-3";